import http from "./ajax";

const API_URL = {
  News: "/api/News",
  Categories: "/api/News/Categories"
};

class newsApi extends http {
  //新聞清單
  Newslist = async (params = {}) => {
    try {
      let url = `${API_URL.News}?page=${params.page}&count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log("Newslistt", err);
    }
  };

  getNewsList = (params = {}) => {
    return this.Newslist(params);
  };

  //帶ID 進入新聞詳細
  NewDetail = async (params = {}) => {
    try {
      let url = `${API_URL.News}/${params.Id}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log("NewsDetail", err);
    }
  };
  getNewsDetail = (params = {}) => {
    return this.NewDetail(params);
  };

  //透過分類ID獲取分類清單
  CategoryNewslist = async (params = {}) => {
    try {
      let url = `${API_URL.News}/${params.Id}/List?count=${params.count}&page=${params.page}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log("NewsDetail", err);
    }
  };
  getCategoryNewslist = (params = {}) => {
    return this.CategoryNewslist(params);
  };

  //獲取分類列表
  NewsCategory = async (params = {}) => {
    try {
      let url = API_URL.Categories;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log("NewsDetail", err);
    }
  };
  getNewsCategory = (params = {}) => {
    return this.NewsCategory(params);
  };
}

export default new newsApi();



// WEBPACK FOOTER //
// ./src/service/news.js